import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { LoginComponent } from './login/login.component';
import {AuthRoutingModule} from "./auth-routing.module";

import { TranslateModule } from '@ngx-translate/core';
import { NgOtpInputModule } from  'ng-otp-input';   
import { SharedModule } from '../shared'; 
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [ 
    LoginComponent, 
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(), 
    NgOtpInputModule,
    AuthRoutingModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  exports: [ 
    LoginComponent
  ]
})
export class AuthModule { }
